import React, { Component } from 'react';
import { string, any } from 'prop-types';
import Link from 'gatsby-link';
import cx from 'classnames';

const CLASS_ROOT = 'card';

class Card extends Component {
  static propTypes = {
    href: string,
    cardRef: any,
  };

  render() {
    const { className, children, href, cardRef, ...other } = this.props;

    const classes = cx(CLASS_ROOT, className);

    return (
      <div ref={cardRef} className={classes} {...other}>
        {href && <Link to={href} className="card__link" />}
        {children}
      </div>
    );
  }
}

export default Card;
